import React from 'react';

export function StatCard({ label, value, icon: Icon, color }) {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 flex items-center justify-between">
      <div>
        <p className="text-sm text-[#7F8C8D] mb-1">{label}</p>
        <p className="text-3xl font-bold text-[#2C3E50]">{value}</p>
      </div>
      <div className={`${color}`}>
        <Icon size={32} />
      </div>
    </div>
  );
}

export default StatCard;
